import React from "react";
import style from "./styles.module.scss";

const List = ({ items }) => {
  return (
    <ul className="pl-0">
      {items.length ? (
        items.map((item) => <Item key={`a-item-${item.id}`} item={item} />)
      ) : (
        <span style={{ textAlign: "center" }}>Process has no related authorizations</span>
      )}
    </ul>
  );
};

const Item = ({ item }) => (
  <li className={style.item}>
    <span style={{ marginRight: "2px" }}>
      <i className={`${getIconName(item.status)} icons font-xl d-block`}></i>
    </span>

    <p>
      <span className={style.title}> {item.title} </span>
      <br />
      <small className="text-muted">{item.text}</small>
      <br />
      <div className="d-flex">
        <span className={style.info}>
          Authorization role: <span className={style.value}>{item.role}</span>
        </span>
      </div>
    </p>
  </li>
);

const getIconName = (status) => {
  switch (status) {
    case "Authorized":
      return "text-buy icon-check";
    case "Rejected":
      return "text-danger icon-close";
    case "Waiting":
      return "icon-clock";
  }
};

export default List;
